module.exports = __webpack_public_path__ + "static/img/7.10e0068.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/7.png
// module id = ea6b
// module chunks = 0